import * as i0 from '@angular/core';
import * as i1 from './accordion-workflow.module';
import * as i2 from '@angular/common';
import * as i3 from '../icon/icon.component';
import * as i4 from './accordion-workflow.component';
import * as i5 from './accordion-workflow-panel.component';
import * as i6 from './accordion-workflow-header.component';
import * as i7 from '../icon/icon.module';
export const BllAccordionWorkflowModuleNgFactory:i0.NgModuleFactory<i1.BllAccordionWorkflowModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.BllIconComponent = (<any>(null as any));
var _decl0_12:i4.BllAccordionWorkflowComponent = (<any>(null as any));
var _decl0_13:i5.BllAccordionWorkflowPanelComponent = (<any>(null as any));
var _decl0_14:i6.BllAccordionWorkflowHeaderComponent = (<any>(null as any));
var _decl0_15:i2.AsyncPipe = (<any>(null as any));
var _decl0_16:i2.UpperCasePipe = (<any>(null as any));
var _decl0_17:i2.LowerCasePipe = (<any>(null as any));
var _decl0_18:i2.JsonPipe = (<any>(null as any));
var _decl0_19:i2.SlicePipe = (<any>(null as any));
var _decl0_20:i2.DecimalPipe = (<any>(null as any));
var _decl0_21:i2.PercentPipe = (<any>(null as any));
var _decl0_22:i2.TitleCasePipe = (<any>(null as any));
var _decl0_23:i2.CurrencyPipe = (<any>(null as any));
var _decl0_24:i2.DatePipe = (<any>(null as any));
var _decl0_25:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_26:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_27:i2.KeyValuePipe = (<any>(null as any));
var _decl0_28:i2.CommonModule = (<any>(null as any));
var _decl0_29:i7.BllIconModule = (<any>(null as any));
var _decl0_30:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_31:i0.ElementRef<any> = (<any>(null as any));
function _View_BllAccordionWorkflowComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_BllAccordionWorkflowComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_BllAccordionWorkflowPanelComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.isOpen;
  currVal_0;
  const currVal_1:any = (!_decl0_13.noDisabledClass && _decl0_13.disabled);
  currVal_1;
}
function _View_BllAccordionWorkflowPanelComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.itemId;
  currVal_0;
  const currVal_1:any = _decl0_13.headerId;
  currVal_1;
  const currVal_2:any = _decl0_13._getExpandedState();
  currVal_2;
  const pd_3:any = ((<any>_decl0_13._bodyAnimationDone(_any)) !== false);
}
function _View_BllAccordionWorkflowHeaderComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_BllAccordionWorkflowHeaderComponent_3_1():void {
  if (_decl0_14.controlGroup) {
    var _any:any = (null as any);
    const currVal_0:any = 'done';
    currVal_0;
    const currVal_1:any = 'tw-text-success';
    currVal_1;
    const currVal_2:any = _decl0_11.currentClassNames;
    currVal_2;
    const currVal_3:any = ((!_decl0_14.isOpen && _decl0_14.firstOpened) && _decl0_14.controlGroup.valid);
    currVal_3;
    const currVal_4:any = 'signature';
    currVal_4;
    const currVal_5:any = 'tw-text-primary';
    currVal_5;
    const currVal_6:any = _decl0_11.currentClassNames;
    currVal_6;
    const currVal_7:any = _decl0_14.isOpen;
    currVal_7;
  }
}
function _View_BllAccordionWorkflowHeaderComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (!_decl0_14.accordion.noDisabledClass && _decl0_14.accordion.disabled);
  currVal_0;
  const currVal_1:any = _decl0_14.iconCenter;
  currVal_1;
  const currVal_2:any = !_decl0_14.iconCenter;
  currVal_2;
  const currVal_3:any = _decl0_14.iconArrow;
  currVal_3;
  const currVal_4:any = (_decl0_14.iconClass + ' tw-m-0');
  currVal_4;
  const currVal_5:any = (_decl0_14.accordion.isOpen? _decl0_14.minusIcon: _decl0_14.plusIcon);
  currVal_5;
  const currVal_6:any = _decl0_11.currentClassNames;
  currVal_6;
  const currVal_7:any = _decl0_14.iconSize;
  currVal_7;
  const currVal_8:any = _decl0_14.controlGroup;
  currVal_8;
}
